import AuthenticatedRoute from './AuthenticatedRoute';
import AuthenticatedRouteContainer from './AuthenticatedRouteContainer';

export default AuthenticatedRouteContainer;
export { AuthenticatedRoute };
